import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateDonationCampaignsRequest = {
    donationCampaigns: '_donationCampaign',
};
var _bulkCreateDonationCampaignsResponse = {
    results: '_bulkDonationCampaignResult',
};
var _bulkDonationCampaignResult = { item: '_donationCampaign' };
var _bulkUpdateDonationCampaignsRequest = {
    donationCampaigns: '_maskedDonationCampaign',
};
var _bulkUpdateDonationCampaignsResponse = {
    results: '_bulkUpdateDonationCampaignsResponseBulkDonationCampaignResult',
};
var _bulkUpdateDonationCampaignsResponseBulkDonationCampaignResult = {
    item: '_donationCampaign',
};
var _bulkUpdateDonationCampaignTagsByFilterRequest = {};
var _bulkUpdateDonationCampaignTagsByFilterResponse = {};
var _bulkUpdateDonationCampaignTagsRequest = {};
var _bulkUpdateDonationCampaignTagsResponse = {};
var _campaignGoal = { endDate: 'google.protobuf.Timestamp' };
var _createDonationCampaignRequest = {
    donationCampaign: '_donationCampaign',
};
var _createDonationCampaignResponse = {
    donationCampaign: '_donationCampaign',
};
var _donationCampaign = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    coverImage: '_image',
    campaignGoal: '_campaignGoal',
};
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getDonationCampaignMetricsRequest = {};
var _getDonationCampaignMetricsResponse = {};
var _getDonationCampaignRequest = {};
var _getDonationCampaignResponse = { donationCampaign: '_donationCampaign' };
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _maskedDonationCampaign = {
    fieldMask: 'google.protobuf.FieldMask',
    donationCampaign: '_donationCampaign',
};
var _queryDonationCampaignsRequest = {};
var _queryDonationCampaignsResponse = {
    donationCampaigns: '_donationCampaign',
};
var _updateDonationCampaignRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    donationCampaign: '_donationCampaign',
};
var _updateDonationCampaignResponse = {
    donationCampaign: '_donationCampaign',
};
function resolveWixDonationsV2DonationCampaignServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/donation-campaign-service/v2',
                destPath: '/v2',
            },
        ],
        _: [
            {
                srcPath: '/_api/donation-campaign-service/v2',
                destPath: '/v2',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/donation-campaign-service/v2',
                destPath: '/v2',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/donation-campaign-service/v2',
                destPath: '/v2',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/donation-campaign-service/v2',
                destPath: '/v2',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/donation-campaign-service/v2',
                destPath: '/v2',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/donation-campaign-service/v2',
                destPath: '/v2',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a new Donation Campaign.
 * A valid payment configuration (either suggested amount, custom amount, or both) must be provided.
 */
export function createDonationCampaign(payload) {
    var _a = serializer(_createDonationCampaignRequest, { _campaignGoal: _campaignGoal, _donationCampaign: _donationCampaign, _focalPoint: _focalPoint, _image: _image }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createDonationCampaignResponse, {
        _campaignGoal: _campaignGoal,
        _donationCampaign: _donationCampaign,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __createDonationCampaign(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v2.donation_campaign',
            method: 'POST',
            methodFqn: 'wix.donations.v2.DonationCampaignService.CreateDonationCampaign',
            url: resolveWixDonationsV2DonationCampaignServiceUrl({
                protoPath: '/v2/donation-campaigns',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createDonationCampaign.fromReq = fromReq;
    __createDonationCampaign.__isAmbassador = true;
    return __createDonationCampaign;
}
/** Retrieves a Donation Campaign by its ID. */
export function getDonationCampaign(payload) {
    var _a = serializer(_getDonationCampaignRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDonationCampaignResponse, {
        _campaignGoal: _campaignGoal,
        _donationCampaign: _donationCampaign,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __getDonationCampaign(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v2.donation_campaign',
            method: 'GET',
            methodFqn: 'wix.donations.v2.DonationCampaignService.GetDonationCampaign',
            url: resolveWixDonationsV2DonationCampaignServiceUrl({
                protoPath: '/v2/donation-campaigns/{donationCampaignId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDonationCampaign.fromReq = fromReq;
    __getDonationCampaign.__isAmbassador = true;
    return __getDonationCampaign;
}
/**
 * Updates a Donation Campaign. Supports partial update.
 *
 * Each update increments the campaign’s `revision` by 1. To avoid conflicts, the current `revision` must be provided in the request.
 */
export function updateDonationCampaign(payload) {
    var _a = serializer(_updateDonationCampaignRequest, { _campaignGoal: _campaignGoal, _donationCampaign: _donationCampaign, _focalPoint: _focalPoint, _image: _image }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateDonationCampaignResponse, {
        _campaignGoal: _campaignGoal,
        _donationCampaign: _donationCampaign,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __updateDonationCampaign(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v2.donation_campaign',
            method: 'PATCH',
            methodFqn: 'wix.donations.v2.DonationCampaignService.UpdateDonationCampaign',
            url: resolveWixDonationsV2DonationCampaignServiceUrl({
                protoPath: '/v2/donation-campaigns/{donationCampaign.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateDonationCampaign.fromReq = fromReq;
    __updateDonationCampaign.__isAmbassador = true;
    return __updateDonationCampaign;
}
/**
 * Retrieves a list of Donation Campaigns based in the provided query criteria (WQL expression).
 *
 * For more details, please refer to:
 * - API Query Language: https://dev.wix.com/docs/rest/articles/getting-started/api-query-language
 * - Sorting and Paging: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
 */
export function queryDonationCampaigns(payload) {
    var _a = serializer(_queryDonationCampaignsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryDonationCampaignsResponse, {
        _campaignGoal: _campaignGoal,
        _donationCampaign: _donationCampaign,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __queryDonationCampaigns(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v2.donation_campaign',
            method: 'GET',
            methodFqn: 'wix.donations.v2.DonationCampaignService.QueryDonationCampaigns',
            url: resolveWixDonationsV2DonationCampaignServiceUrl({
                protoPath: '/v2/donation-campaigns/query',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixDonationsV2DonationCampaignServiceUrl({
                        protoPath: '/v2/donation-campaigns/query',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __queryDonationCampaigns.fromReq = fromReq;
    __queryDonationCampaigns.__isAmbassador = true;
    return __queryDonationCampaigns;
}
/**
 * Bulk creates multiple Donation Campaigns.
 * If `return_entity` is set to true, the created entities are returned in the response.
 * Some requirements and validations in the single create end point apply here as well.
 */
export function bulkCreateDonationCampaigns(payload) {
    var _a = serializer(_bulkCreateDonationCampaignsRequest, { _campaignGoal: _campaignGoal, _donationCampaign: _donationCampaign, _focalPoint: _focalPoint, _image: _image }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateDonationCampaignsResponse, {
        _bulkDonationCampaignResult: _bulkDonationCampaignResult,
        _campaignGoal: _campaignGoal,
        _donationCampaign: _donationCampaign,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __bulkCreateDonationCampaigns(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v2.donation_campaign',
            method: 'POST',
            methodFqn: 'wix.donations.v2.DonationCampaignService.BulkCreateDonationCampaigns',
            url: resolveWixDonationsV2DonationCampaignServiceUrl({
                protoPath: '/v2/bulk/donation-campaigns/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateDonationCampaigns.fromReq = fromReq;
    __bulkCreateDonationCampaigns.__isAmbassador = true;
    return __bulkCreateDonationCampaigns;
}
/**
 * Bulk updates multiple Donation Campaigns.
 * If `return_entity` is set to true, the updated entities are returned in the response.
 * Some requirements and validations in the single update end point apply here as well.
 */
export function bulkUpdateDonationCampaigns(payload) {
    var _a = serializer(_bulkUpdateDonationCampaignsRequest, {
        _campaignGoal: _campaignGoal,
        _donationCampaign: _donationCampaign,
        _focalPoint: _focalPoint,
        _image: _image,
        _maskedDonationCampaign: _maskedDonationCampaign,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateDonationCampaignsResponse, {
        _bulkUpdateDonationCampaignsResponseBulkDonationCampaignResult: _bulkUpdateDonationCampaignsResponseBulkDonationCampaignResult,
        _campaignGoal: _campaignGoal,
        _donationCampaign: _donationCampaign,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __bulkUpdateDonationCampaigns(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v2.donation_campaign',
            method: 'POST',
            methodFqn: 'wix.donations.v2.DonationCampaignService.BulkUpdateDonationCampaigns',
            url: resolveWixDonationsV2DonationCampaignServiceUrl({
                protoPath: '/v2/bulk/donation-campaigns/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateDonationCampaigns.fromReq = fromReq;
    __bulkUpdateDonationCampaigns.__isAmbassador = true;
    return __bulkUpdateDonationCampaigns;
}
/**
 * Retrieves metrics for a specific Donation Campaign.
 * Setting a campaign goal is a prerequisite for this operation.
 *
 * Returns: the number of successful donations and the total monetary amount collected for the campaign so far.
 */
export function getDonationCampaignMetrics(payload) {
    var _a = serializer(_getDonationCampaignMetricsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDonationCampaignMetricsResponse, {}).fromJSON;
    function __getDonationCampaignMetrics(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v2.donation_campaign',
            method: 'GET',
            methodFqn: 'wix.donations.v2.DonationCampaignService.GetDonationCampaignMetrics',
            url: resolveWixDonationsV2DonationCampaignServiceUrl({
                protoPath: '/v2/donation-campaigns/{donationCampaignId}/metrics',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDonationCampaignMetrics.fromReq = fromReq;
    __getDonationCampaignMetrics.__isAmbassador = true;
    return __getDonationCampaignMetrics;
}
/**
 * Synchronously update tags on multiple Donation Campaigns.
 * A tag that appears both in the list of assign and unassign tags, will be assigned.
 */
export function bulkUpdateDonationCampaignTags(payload) {
    var _a = serializer(_bulkUpdateDonationCampaignTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateDonationCampaignTagsResponse, {}).fromJSON;
    function __bulkUpdateDonationCampaignTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v2.donation_campaign',
            method: 'POST',
            methodFqn: 'wix.donations.v2.DonationCampaignService.BulkUpdateDonationCampaignTags',
            url: resolveWixDonationsV2DonationCampaignServiceUrl({
                protoPath: '/v2/bulk/donation-campaigns/update-tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateDonationCampaignTags.fromReq = fromReq;
    __bulkUpdateDonationCampaignTags.__isAmbassador = true;
    return __bulkUpdateDonationCampaignTags;
}
/**
 * Asynchronously update tags on multiple Donation Campaigns based on a provided filter.
 * An empty filter will update all Donation Campaigns.
 * A tag that appears both in the list of assign and unassign tags, will be assigned.
 */
export function bulkUpdateDonationCampaignTagsByFilter(payload) {
    var _a = serializer(_bulkUpdateDonationCampaignTagsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateDonationCampaignTagsByFilterResponse, {}).fromJSON;
    function __bulkUpdateDonationCampaignTagsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.donations.v2.donation_campaign',
            method: 'POST',
            methodFqn: 'wix.donations.v2.DonationCampaignService.BulkUpdateDonationCampaignTagsByFilter',
            url: resolveWixDonationsV2DonationCampaignServiceUrl({
                protoPath: '/v2/bulk/donation-campaigns/update-tags-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateDonationCampaignTagsByFilter.fromReq = fromReq;
    __bulkUpdateDonationCampaignTagsByFilter.__isAmbassador = true;
    return __bulkUpdateDonationCampaignTagsByFilter;
}
//# sourceMappingURL=http.impl.js.map